export default __webpack_public_path__ + "static/media/big-brain.720ac265.png";